import React from "react";
import Card from "./Card";
import Header from "./Header";
import Footer from "./Footer";
import movieData from "./movieData";


let movieCard = (val) => {
  return (
    <Card
      moviePoster={val.moviePoster}
      genre={val.genre}
      title={val.title}
      link={val.link}
    />
  );
};

function App() {
  return (
    <>
      <Header />
      <div className='container'>{movieData.map(movieCard)};</div>
      <Footer />
    </>
  );
}
export default App;
